import moment from "moment";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import styled from "styled-components";
import XrButtonAv from '../../../components/XrButtonAv.tsx';
import XrDataTable from '../../../components/XrDataTable.tsx';
import { apiGet, objectToParams, API_URL_BOOKING } from "../../../helpers/api.ts";

const ListBookingPage = () => {
  const token = useSelector((state) => state.authentication.token);
  const authorizedUser = useSelector((state) => state.authentication.authorizedUser);

  const [isLoading, setLoading] = useState(false);
  const [bookings, setBookings] = useState([]);

  const populateData = async () => {
    if (!authorizedUser || isLoading) return;
    setLoading(true);
    try {
      const payload = {
        status: 'codex',
        id_user: authorizedUser.id
      };
      const request = await apiGet(`${API_URL_BOOKING.FILTER_BOOKING}?${objectToParams(payload)}`, token);
      const result = await request.json();
      setBookings(result.data);
    } catch (e) {
      console.log(e);
      toast.error('Terjadi kesalahan pada server, mohon coba kembali.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    populateData();
  }, []);

  const renderBookingList = () => {
    if (isLoading) {
      return (
        <tr>
          <td colSpan={6} className="tablewrapper--loading">
            <div className="tablewrapper--loading--caption">
              <span>Memuat data...</span>
            </div>
          </td>
        </tr>
      );
    }

    if (bookings.length > 0) {
      return bookings.map(booking => {
        return (
          <tr key={booking.id}>
            <td>
              <XrButtonAv
                size='large'
                caption='Lihat Detail'
                style={{ width: '150px' }}
                href={`/submissions/${booking.id}`}
              />
            </td>
            <td>{booking.description}</td>
            <td>{moment(booking.start_date).format('DD MMM YYYY')}</td>
            <td>{moment(booking.start_date).format('HH:MM:SS')}</td>
            <td>{moment(booking.end_date).format('HH:MM:SS')}</td>
            <td>{booking.user_detail?.name}</td>
          </tr>
        );
      })
    } else {
      return (
        <tr style={{ textAlign: 'center' }}>
          <td colSpan={7}>Tidak ada permintaan peminjaman yang diajukan.</td>
        </tr>
      );
    }
  }

  return (
    <ListBookingPageWrapper>
      <XrDataTable>
        <div className="tablewrapper--title">
          Daftar Peminjaman
        </div>
        <div className="tablewrapper--table">
          <table>
            <thead>
              <tr>
                <th></th>
                <th>Deskripsi</th>
                <th>Tanggal</th>
                <th>Mulai</th>
                <th>Selesai</th>
                <th>PIC</th>
              </tr>
            </thead>
            <tbody>
              {renderBookingList()}
            </tbody>
          </table>
        </div>
      </XrDataTable>
    </ListBookingPageWrapper>
  );
}

const ListBookingPageWrapper = styled.div`
  padding: 40px;
`;

export default ListBookingPage;